<irembogov-custom-table-wrapper
  [isSortVisible]="field.props?.['isSortVisible']"
  [isSeachVisible]="field.props?.['isSearchVisible']"
  [sortFieldOptions]="sortOptions"
  [selectedSortField]="selectedSort"
  [tableTitle]="field.props?.['tableTitle']"
  [loading]="loading"
  [paginationVisible]="field.props?.['paginationVisible']"
  [paginationInsideTable]="field.props?.['paginationInsideTable']"
  [totalItems]="totalItems"
  [pageSizes]="field.props?.['pageSizes'] || [10, 50, 100]"
  [itemsPerPage]="itemsPerPage || 10"
  [currentPage]="currentPage"
  [showDropdown]="field.props?.['showDropdown']"
  [roundedTable]="field.props?.['roundedTable']"
  [searchPlaceholder]="field.props?.['searchPlaceholder'] || 'Search'"
  (paginationChange)="onPageChange($event)"
  (sortChange)="onSortChange($event)"
  (searchChange)="onSearch($event)">
  <div body>
    <table [class]="field.props?.['tableClass'] || 'table'">
      <thead>
        <tr>
          <th
            *ngIf="isSelectable"
            class="selection-column"
            style="width: fit-content">
            <!-- Header for selection column -->
          </th>
          <th *ngFor="let col of columns" [style.width]="col.width || 'auto'">
            {{ col.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of tableData; let i = index"
          [class.selected-row]="isRowSelected(i)"
          [class.cursor-pointer]="isSelectable"
          (click)="isSelectable && onRowSelect(i, row)"
          (keydown)="
            isSelectable && $event.key === 'Enter' && onRowSelect(i, row)
          "
          tabindex="0">
          <td *ngIf="isSelectable" class="selection-column">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                [checked]="isRowSelected(i)"
                [disabled]="
                  !isRowSelected(i) && selectedRows.size >= maxSelectable
                "
                (click)="$event.stopPropagation()"
                (change)="onRowSelect(i, row)"
                (keydown)="$event.key === 'Enter' && onRowSelect(i, row)" />
            </div>
          </td>
          <td
            *ngFor="let col of columns"
            [style.width]="col.width || 'auto'"
            [class.nowrap]="col.nowrap">
            <div [class]="!col.nowrap ? '' : 'text-wrapper wrap'">
              {{ getCellValue(row, col) }}
            </div>
          </td>
        </tr>
        <!-- No data row -->
        <tr *ngIf="!loading && tableData.length === 0">
          <td
            [attr.colspan]="columns.length + (isSelectable ? 1 : 0)"
            class="text-center py-4">
            <div class="text-muted">
              {{ field.props?.['noDataMessage'] || 'No data available' }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</irembogov-custom-table-wrapper>
